// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4946) return "static/chunks/4946-df9d2cbace7b516c.js";
	if (chunkId === 2884) return "static/chunks/2884-37db439576dc6efe.js";
	if (chunkId === 3800) return "static/chunks/3800-f0cfa2925efe5551.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"87":"0b586496ff9a931f","706":"58174bd22e9229c1","1605":"b5b72a63b4075d70","2626":"a884f26f5c89cd79","4318":"b7a505fc6d271971","4473":"400c1f2635b87b5e","6556":"06294e975a7f5b7b"}[chunkId] + ".js";
};